module.exports = __webpack_public_path__ + "img/ic_fluent_save_20_regular.a74db69a.svg";